<lib-dynamic-dropdown
  [list]="productCategoryList"
  [(ngModel)]="value"
  [isPrimitive]="true"
  required
  [placeholder]="'placeholderSelect' | translate: {placeholder: 'product' | translate} "
  (ngModelChange)="onValueChange($event)"
>
  <ng-template
    dropdownSelectedItemTpl
    let-selectedOption
  >
    <div class="flex items-center gap-2">
      <img
        [src]="selectedOption.imageUrl"
        class="w-[18px]"
      />
      <div>{{ selectedOption.name }}</div>
    </div>
  </ng-template>
  <ng-template
    dropdownItemTpl
    let-item
  >
    <div class="flex items-center gap-2">
      <img
        [src]="item.imageUrl"
        class="w-[18px]"
      />
      <div>{{ item.name }}</div>
    </div>
  </ng-template>
</lib-dynamic-dropdown>